import React, { useState } from 'react'
import { Upload } from '@mui/icons-material'
import { MenuItem, OutlinedInput, Select, Typography } from '@mui/material'
import { saveAs } from 'file-saver'
import { useParams } from 'react-router-dom'
import api from '../../../api'
import { showError, toCamelCase } from '../../../utils/helper'
import Button from '../../../components/UI/CustomButton'
import toast from 'react-hot-toast'
import { trackPromise } from 'react-promise-tracker'
import SplitButton from '../SplitButton'

type Props = {
  APIKey: string
  fromDate?: any
  toDate?: any
  platform?: any
  subsidiaryId?: any
}

const HandleExport = (props: Props) => {
  const { APIKey, fromDate, toDate, platform,subsidiaryId } = props
  const params = useParams()
  const { id } = params
  const [format, setFormat] = useState('xlsx') as any
  const [exportLoader, setExportLoader] = useState(false)
  const [buttonPopup, setButtonPopup] = useState(false)

  const getResponse = () => {
    if (APIKey === 'observation') {
      return api.getExportObservations(id, format, fromDate, toDate)
    } else if (APIKey === 'observation-view') {
      return api.getExportObservationsView(id, format,subsidiaryId)
    } else if (APIKey === 'statisticsCapture') {
      return api.getExportReport(id, format)
    } else if (APIKey === 'statisticCaptureSchedule') {
      return api.getExportStatisticCaptureSchedule(id, format)
    } else if (APIKey === 'inspectionSchedule') {
      return api.getExportInspectionSchedule(id, format)
    } else if (APIKey === 'inspections') {
      return api.getExportInspections(id, format)
    } else if (APIKey === 'auditSchedule') {
      return api.getExportAuditSchedule(id, format)
    } else if (APIKey === 'audits') {
      return api.getExportAudits(id, format)
    } else if (APIKey === 'inspectionsNonConformance') {
      return api.getExportInspectionsNonConformance(id, format)
    } else if (APIKey === 'recent-queries') {
      return api.getExportRecentQueries(id, format, platform, fromDate, toDate)
    } else if (APIKey === 'incident') {
      return api.getExportIncident(id, format)
    }else if (APIKey === 'incident-view') {
      return api.getExportIncidentView(id, format,subsidiaryId)
    }  else if (APIKey === 'training') {
      return api.getExportTraining(id, format)
    } else if (APIKey === 'quizAssessment') {
      toast.success('Coming Soon!')
      // return api.getExportQuizAssessments(format, id)
    } else if (APIKey === 'training-view') {
      return api.getExportTrainingView(id, format,subsidiaryId)
    }
  }

  const handleExport = async () => {
    try {
      setExportLoader(true)

      // Fetch data from the API
      const response = await getResponse()

      if (response?.data?.meta?.code === 400) {
        return showError(response)
      }

      if (!response) {
        throw new Error('No data received from the API.')
      }

      if (format === 'xlsx') {
        // handleXlsxExport(response)
      } else if (format === 'csv') {
        handleCsvExport(response)
      } else {
        throw new Error(`Unsupported format: ${format}`)
      }
    } catch (error) {
      console.error('Error during export:', error)
      showError('Export failed. Please try again.')
    } finally {
      setExportLoader(false)
    }
  }

  // Handle CSV export
  const handleCsvExport = (response: any) => {
    const csvContent = response.data || response // Adjust as per API response
    const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    saveAs(csvBlob, `${toCamelCase(APIKey || '')}.csv`)
  }

  const handleDownload = async () => {
    try {
      setExportLoader(true)
      const resp = (await getResponse()) as any
      console.log(resp)
      if (resp?.status === 200) {
        // Handle custom error codes
        if (resp?.data?.meta?.code === 400) {
          toast.error(resp?.data?.meta?.message)
          return
        }
        // Create a Blob from the response data
        const blob = new Blob([resp.data], { type: resp.headers['content-type'] })

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob)

        // Create an anchor element to trigger the download
        const link = document.createElement('a')
        link.href = url

        // Extract filename from Content-Disposition header
        const contentDisposition = resp.headers['content-disposition']
        const fileName = contentDisposition ? toCamelCase(contentDisposition.split('filename=')[1] || '') : `${toCamelCase(APIKey || '') || 'download'}.xlsx` // Default name if filename isn't provided
        link.download = fileName.replace(/['"]+/g, '') // Remove quotes if present

        // Trigger download
        document.body.appendChild(link)
        link.click()

        // Cleanup
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } else {
        toast.error('Unable to export, Please try again.')
      }
    } catch (error: any) {
      toast.error('Unable to export, Please try again.')
    } finally {
      setExportLoader(false)
    }
  }

  return (
    <div className="flex items-center">
      {/* <Select
        size="small"
        className="w-[80px] text-textSecondary mr-3"
        displayEmpty
        value={format}
        onChange={(e: any) => setFormat(e?.target?.value)}
        input={<OutlinedInput />}
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            padding: '0 !important',
            margin: '0 !important',
            borderRadius: '8px',
          },
        }}
      >
        {[
          {
            label: '.xlsx',
            value: 'xlsx',
          },
          {
            label: '.csv',
            value: 'csv',
          },
        ].map((name: any) => (
          <MenuItem disabled={name?.is_disable} key={name.label} value={name.value}>
            {name.label}
          </MenuItem>
        ))}
      </Select> */}
      {/* <Button variant="outlined" onClick={() => (format === 'xlsx' ? handleDownload() : handleExport())} className="z-10" loader={exportLoader} disabled={exportLoader}>
        <Upload className="mr-2" fontSize="small" />
        Export
      </Button> */}
      <SplitButton
        handleClick={() => {
          format === 'xlsx' ? handleDownload() : handleExport()
        }}
        open={buttonPopup}
        setOpen={setButtonPopup}
        selectedIndex={format === 'xlsx' ? 0 : 1}
        setSelectedIndex={(e: any) => setFormat(e ? 'csv' : 'xlsx')}
        loader={exportLoader}
        propOptions={[
          <Typography>
            <Upload className="mr-2" fontSize="small" /> Export <small>{`.xlsx`}</small>
          </Typography>,
          <Typography>
            <Upload className="mr-2" fontSize="small" /> Export <small>.csv</small>
          </Typography>,
        ]}
      />
    </div>
  )
}

export default HandleExport
